<template>
    <nav>
        <v-app-bar 
        :collapse-on-scroll="cols"
        inverted-scroll
        flat app>
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        </v-app-bar>

        <v-navigation-drawer app temporary v-model="drawer" color=#F2EFE8 >
            <v-list>
                <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
                    <v-list-item-icon>
                        <v-icon color=#1765B3>{{link.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        {{link.text}}
                    </v-list-item-content>
                </v-list-item>
            </v-list> 
        </v-navigation-drawer>
    </nav>
</template>

<script>
export default {
    name: 'Navbar',
    computed: {
    cols () {
        const {mdAndDown } = this.$vuetify.breakpoint
        return mdAndDown ? false : true
        },
    },
    data() {
        return {
            drawer: false,
            links: [
                {
                    icon: "fas fa-record-vinyl", 
                    text: "jazzterdays", 
                    route: '/#home',
                },
                {icon: "fas fa-record-vinyl", text: "about", route: '/#about'},
                {icon: "fas fa-record-vinyl", text: "personal", route: '/#staff'},
                {icon: "fas fa-record-vinyl", text: "neues", route: '/#news'},
                {icon: "fas fa-record-vinyl", text: "termine", route: '/#dates'},
                {icon: "fas fa-record-vinyl", text: "kontakt", route: '/#contact'},
                // {icon: "fab fa-canadian-maple-leaf", text: "herbst", route: '/herbst'},
                {icon: "fas fa-record-vinyl", text: "impressum", route: '/impressum'},
                // {icon: "fas fa-stamp", text: "impressum", route: '/impressum'},
                // {icon: "fas fa-file-audio", text: "impressum", route: '/impressum'},
            ]
        }
    }
}
</script>